export default "__VITE_ASSET__effe3e58__"